import React from "react";
import { SegmentProps, Segment } from "semantic-ui-react";

export const LoaderSegment: React.FC<SegmentProps> = (props) => (
    <Segment {...props} loading padded="very" />
);
